module.exports = __webpack_public_path__ + "static/img/front.3f0d7f07.jpg";